import { render, staticRenderFns } from "./time-fill-tag.vue?vue&type=template&id=6533b152&scoped=true"
import script from "./time-fill-tag.vue?vue&type=script&lang=ts"
export * from "./time-fill-tag.vue?vue&type=script&lang=ts"
import style0 from "./time-fill-tag.vue?vue&type=style&index=0&id=6533b152&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6533b152",
  null
  
)

export default component.exports